import React, { useState } from 'react';
import Menu from './menu';
import Sidebar from './sidebar';
import Footer from './footer';
import blogImg from '../assets/blog.jpg'; // Import the image file
import dtone from '../assets/dt1.png'; // Import the image file
import { Link, useLocation } from 'react-router-dom';
import dttwo from '../assets/paralympic-games.jpeg'; // Import the image file
import dtthree from '../assets/goldss.jpg'; // Import the image file
import table from '../assets/table.jpg'; // Import the image file
import modi from '../assets/modi.png'; // Import the image file

const Paralympics = () => {

  return (
    <div>
<div className="container mt-5">
        <div className="row">
          <div className="col-sm-12 col-lg-3 col-xl-3 col-md-3">
            <Sidebar />
          </div>
          <div className="col-sm-12 col-lg-9 col-xl-9 col-md-9">
            <Menu />
            <div className="bostami-page-content-wrap">
              <section className="">
                <div className="section-wrapper pl-60 pr-60 pt-60">
                  <div className="bostami-page-title-wrap mb-15">
                    <div className="three">
                      <h1 className="">Digital Twin</h1>
                    </div>
                    <div className="card shadow-lg p-5 mt-5 mb-5" style={{ border: 'none', borderLeft: '6px solid #1b74e4', borderRadius: '10px' }}>
                 <div class="row">
                    <div class="col-sm-12 col-lg-4 col-xl-4 col-md-4">
                        <img src={dttwo} style={{height:'200px',width:'200px',borderRadius:'15px'}}alt="dt"/>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-xl-8 col-md-8">
                   
                  <p class="">India’s journey in the Paralympics began in 1968 when the country made its debut in the Games. Since then, Indian athletes have steadily progressed, overcoming numerous challenges to reach where they are today. The Paris Paralympics 2024 is a testament to this progress, as India competes with increased confidence and ambition.</p>
                    </div>
               <p class="mt-4">As the world gears up for the 2024 Paralympic Games in Paris, India is eagerly anticipating another remarkable performance from its para-athletes. The Paralympics, which will be held from August 28 to September 8, 2024, promises to be a celebration of grit, determination, and excellence in sports. For India, this event holds special significance as the nation’s para-athletes continue to raise the bar with their exceptional performances on the global stage.</p>

                 </div>  
                </div>
                <div className="card shadow-lg p-5 mt-5 mb-5" style={{ border: 'none', borderRight: '6px solid #1b74e4', borderRadius: '10px' }}>
                <div class="row">
                    <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                    
                  <p class="mt-4">India is proudly represented by 84 para-athletes, including 32 women, at the Paris event. This edition marks a significant milestone as India debuts in three new sports: para-cycling, para-rowing, and blind judo. With these additions, India will now compete in a total of 12 events, contributing to the 22 sports disciplines featured in this edition.
The medals also meant that India recorded their best-ever result at the Paralympic Games, surpassing the record from Tokyo 2020.

</p>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <img src={dtthree}  style={{height:'200px',width:'200px',borderRadius:'15px'}}alt="dt"/>
                    </div>
               <p>The Indian contingent concluded its historic Paris Paralympics campaign with 29 medals, including seven gold, nine silver, and 13 bronze medals, marking the country’s best performance in the competition’s history. India also crossed the 50-medal mark in Paralympic Games history with this impressive performance.
The Paris Paralympic Games 2024 concluded for India on Sunday, with Pooja Ojha the final athlete in action. Ojha failed to qualify for the women's kayak 200m final and bowed out of the competition. As a result, India's medals tally at the Paris Paralympics ended at 29 -- seven golds, nine silvers and 13 bronze, making it the most rewarded campaign for the country. Courtesy of the 29 medals, India stood at the 18th position in the points table. Pakistan, who were also competing win the event, ended the campaign joint-bottom at the 79th position, with just a solitary bronze to its name
</p>


                </div>
                
                </div>
                <div className="three mt-5">
                <h3 className="company" style={{color:'#1773ea'}}>Digital Twin</h3>
                    </div>
<p>India has won seven gold medals, nine silver medals and 13 bronze medals in Paris 2024. With this landmark achievement, India has surpassed its previously most successful campaign at the Tokyo 2020 Paralympics, where they secured 19 medals, including five golds, eight silver, and six bronze medals.</p>
<p>India did very well in the 2024 campaign, beating top nations like Switzerland, Belgium, South Korea, Turkey, Argentina, etc. to finish the Paris Para Games among the top 20 countries in the world.</p>
<img src={table} class="img-fluid" style={{width:'700px'}}/>
<p>A record 84 para-athletes represented the tricolour from August 28 to the conclusion of the event on Sunday, competing across 12 disciplines, compared to just nine in Tokyo 2020. India also made its debut in three sports in Paris: paracycling, para rowing, and blind judo.</p>
<p>The 29 medals were won across five sports, with a remarkable 17 coming from track and field events. This ensured that India finished in the top 20 of the medal standings at the mega-event, which was once again dominated by China.</p>
<p>China topped the Paralympics medals table with 220 medals, including 94 golds, after all events were completed on the final day of competition on Sunday. China has led the medal standings at every Paralympics since Athens 2004. Great Britain finished second in Paris with 49 golds, followed by the United States, which claimed 36 titles.</p>
   <p>The record haul also meant that India crossed the 50-medal mark in their <b>Paralympic history.</b></p>
   <p>A record 84 para-athletes represented India at the <b>Paris 2024 Paralympics,</b> held in the French capital from August 28 to September 8. India competed across 12 disciplines, three more than at Tokyo 2020. Indian para-athletes participated in three new sports at <b>Paris 2024</b>—para cycling, para rowing, and blind judo.</p>
   <p><b>India had some impressive performances at the Paris 2024 Paralympic Games.</b></p>
   <p><b>Avani Lekhara </b>became the first Indian woman to win two gold medals at the Paralympic Games, defending her title in the women's 10m air rifle standing SH1<b> shooting </b>event with a world record score.</p>
  <p>India recorded a one-two in athletics for the first time, with Dharambir and Parnav Soorma clinching gold and silver, respectively, in the men's club throw F51 event. Dharambir also set a new Asian record of 34.92m. Later, Praveen Kumar also logged an Asian record to win the high jump T64 title and fetched India's sixth gold, their highest ever at the Paralympics.</p>
<p>Javelin ace <b>Sumit Antil</b> too made history as the first Indian man to defend his title at the Paralympics, winning gold in the <b>men's javelin</b> throw F64 with a stunning throw of 70.59m —a new Paralympic record. Remarkably, Sumit broke his own previous record, set at the Tokyo 2020 Paralympics, not just once, but three times during the competition.</p>
<p>With a bronze in the high jump T42 class, <b>Mariyappan Thangavelu </b>became the first Indian to win medals at three consecutive Paralympics. He won the gold medal at Rio 2016 and silver at Tokyo 2020.</p>
<p><b>Preethi Pal</b> secured her bronze in the women's 100m T35 race with a personal best time. It was India's first-ever medal in a track event at the Paralympics. Her bronze in the 200m made her India's most successful athlete at the Games, as she was the only one to secure two medals.</p>
<p>In all, India won four medals in track events at Paris 2024. It included <b>Deepthi Jeevanji,</b> who became the first intellectually impaired Indian athlete to win a Paralympic medal with a bronze in the women’s 400m T20 class.</p>
<p>Records were set in <b>archery </b>too. Armless archer <b>Sheetal Devi </b>briefly set a world record in the ranking round before finishing in second place. But she teamed up with Rakesh Kumar later to achieve a world record score in the compound mixed team qualification event. At just 17 years old, Sheetal went on to make history as India’s youngest Paralympic medallist, securing bronze in the mixed team event alongside Rakesh.</p>
      <p>Later, India found their first-ever Paralympic <b>archery</b> champion in <b>Harvinder Singh.</b></p>
      
                
      <h2>India medal winners at Paris 2024 Paralympics</h2>
      <table class="table table-bordered mt-5">
  <thead>
    <tr>
      <th scope="col">No.</th>
      <th scope="col">Athlete</th>
      <th scope="col">Sport</th>
      <th scope="col">Event</th>
      <th scope="col">Medal</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td>Avani Lekhara</td>
      <td>Shooting</td>
      <td>Women's 10m air rifle standing SH1</td>
      <td>Gold</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>Mona Agarwal</td>
      <td>Shooting</td>
      <td>Women's 10m air rifle standing SH1</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td>Preethi Pal</td>
      <td>Athletics</td>
      <td>Women's 100m T35</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td>Manish Narwal</td>
      <td>Shooting</td>
      <td>Men's 10m air pistol SH1</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">5</th>
      <td>Rubina Francis</td>
      <td>Shooting</td>
      <td>Women's 10m Air Pistol SH1</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">6</th>
      <td>Preethi Pal</td>
      <td>Athletics</td>
      <td>Women's 200m T35</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">7</th>
      <td>Nishad Kumar</td>
      <td>Athletics</td>
      <td>Men's high jump T47</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">8</th>
      <td>Yogesh Kathuniya</td>
      <td>Athletics</td>
      <td>Men's discus throw F56</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">9</th>
      <td>Nitesh Kumar</td>
      <td>Badminton</td>
      <td>Men's singles SL3</td>
      <td>Gold</td>
    </tr>
    <tr>
      <th scope="row">10</th>
      <td>Thulasimathi Murugesan</td>
      <td>Badminton</td>
      <td>Women’s singles SU5</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">11</th>
      <td>Manisha Ramadass</td>
      <td>Badminton</td>
      <td>Women’s singles SU5</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">12</th>
      <td>Suhas Yathiraj</td>
      <td>Badminton</td>
      <td>Men’s singles SL4</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">13</th>
      <td>Rakesh Kumar / Sheetal Devi</td>
      <td>Archery</td>
      <td>Mixed team compound open</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">14</th>
      <td>Sumit Antil</td>
      <td>Athletics</td>
      <td>Javelin throw F64</td>
      <td>Gold</td>
    </tr>
    <tr>
      <th scope="row">15</th>
      <td>Nithya Sre Sivan</td>
      <td>Badminton</td>
      <td>Women's singles SH6</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">16</th>
      <td>Deepthi Jeevanji</td>
      <td>Athletics</td>
      <td>Women's 400m T20</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">17</th>
      <td>Mariyappan Thangavelu</td>
      <td>Athletics</td>
      <td>Men's high jump T63</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">18</th>
      <td>Sharad Kumar</td>
      <td>Athletics</td>
      <td>Men's high jump T63</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">19</th>
      <td>Ajeet Singh</td>
      <td>Athletics</td>
      <td>Men's javelin throw F46</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">20</th>
      <td>Sundar Singh Gurjar</td>
      <td>Athletics</td>
      <td>Men's javelin throw F46</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">21</th>
      <td>Sachin Khilari</td>
      <td>Athletics</td>
      <td>Men's shot put F46</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">22</th>
      <td>Harvinder Singh</td>
      <td>Archery</td>
      <td>Men's individual recurve open</td>
      <td>Gold</td>
    </tr>
    <tr>
      <th scope="row">23</th>
      <td>Dharambir</td>
      <td>Athletics</td>
      <td>Men's club throw F51</td>
      <td>Gold</td>
    </tr>
    <tr>
      <th scope="row">24</th>
      <td>Parnav Soorma</td>
      <td>Athletics</td>
      <td>Men's club throw F51</td>
      <td>Silver</td>
    </tr>
    <tr>
      <th scope="row">25</th>
      <td>Kapil Parmar</td>
      <td>Judo</td>
      <td>Men's -60kg J1</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">26</th>
      <td>Praveen Kumar</td>
      <td>Athletics</td>
      <td>Men's high jump T64</td>
      <td>Gold</td>
    </tr>
    <tr>
      <th scope="row">27</th>
      <td>Hokato Hotozhe Sema</td>
      <td>Athletics</td>
      <td>Men's shot put F57</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">28</th>
      <td>Simran</td>
      <td>Athletics</td>
      <td>Women's 200m T12</td>
      <td>Bronze</td>
    </tr>
    <tr>
      <th scope="row">29</th>
      <td>Navdeep Singh</td>
      <td>Athletics</td>
      <td>Men's javelin throw F41</td>
      <td>Gold</td>
    </tr>
  </tbody>
</table>

                   
<div className="container mt-5">
  <h3>Avani Lekhara</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won India’s first gold medal in the women’s 10 m air rifle event.</li>
    <li style={{ fontSize: '15px' }}>This was her second consecutive gold in the event, making her the first Indian woman to win multiple medals at the Paralympics.</li>
    <li style={{ fontSize: '15px' }}>Mona Agarwal won bronze in the same event.</li>
  </ul>

  <h3>Kumar Nitesh</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won India's second gold in the men's singles SL3 badminton event, following Pramod Bhagat’s gold in the same event at the previous Paralympics.</li>
  </ul>

  <h3>Sumit Antil</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Secured back-to-back gold medals in the men’s javelin throw F64 event.</li>
    <li style={{ fontSize: '15px' }}>Set two Paralympic records during his performance.</li>
  </ul>

  <h3>Harvinder Singh</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won India’s first-ever Paralympic gold medal in archery.</li>
    <li style={{ fontSize: '15px' }}>This was his second Paralympic medal, having previously won bronze at the 2020 Paralympics.</li>
  </ul>

  <h3>Dharambir Nain</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Clinched India’s fifth gold medal in the men’s club throw F51 event.</li>
  </ul>

  <h3>Praveen Kumar</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won another gold medal on the same day in the men’s high jump T64 event.</li>
  </ul>

  <h3>Navdeep Singh</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won India’s seventh gold in the men’s javelin throw F41 category.</li>
    <li style={{ fontSize: '15px' }}>Initially awarded silver, he was upgraded to gold after Iran’s Sadegh Beit Sayah was disqualified.</li>
    <li style={{ fontSize: '15px' }}>Navdeep’s throw of 47.32 meters is now the Paralympic record for the men’s javelin throw F41 category.</li>
  </ul>

  <h3 style={{color:'#1773ea'}}>Silver Medallists Highlights:</h3>

  <h3>Manish Narwal</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won India's first silver medal in the men's 10 m air pistol event.</li>
    <li style={{ fontSize: '15px' }}>This was his second Paralympic medal after winning gold at the 2020 Tokyo Games.</li>
  </ul>

  <h3>Nishad Kumar</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Secured a silver medal in the men’s high jump T47 event.</li>
    <li style={{ fontSize: '15px' }}>Repeated his performance from the Tokyo 2020 Paralympic Games.</li>
  </ul>

  <h3>Yogesh Kathuniya</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won silver in the men’s discus throw F56 event, also repeating his Tokyo 2020 achievement.</li>
  </ul>

  <h3>Thulasimathi Murugesan</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Bagged the only Indian silver medal in the women’s badminton event.</li>
  </ul>

  <h3>Suhas Yathiraj</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won a silver medal in the men’s singles SL4 para-badminton event for the second consecutive Paralympic Games.</li>
  </ul>

  <h3>Ajeet Singh Yadav</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Claimed silver in the men’s javelin throw F46 event.</li>
  </ul>

  <h3>Sundar Singh Gurjar</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Secured bronze in the men’s javelin throw F46 event.</li>
    <li style={{ fontSize: '15px' }}>This was his second Paralympic medal after winning bronze in the same event at the previous Games.</li>
  </ul>

  <h3>Sharad Kumar</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won a silver medal in the men’s high jump T63 event.</li>
    <li style={{ fontSize: '15px' }}>This was his second Paralympic medal.</li>
  </ul>

  <h3 >Mariyappan Thangavelu</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Earned a bronze in the men’s high jump T63 event.</li>
    <li style={{ fontSize: '15px' }}>Achieved a medal in his third consecutive Paralympic Games.</li>
  </ul>

  <h3>Sachin Khilari</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won silver in the men’s shot put F46 event, contributing to India’s fifth athletics silver.</li>
  </ul>

  <h3 style={{color:'#1773ea'}}>Bronze Medallists Highlights:</h3>

  <h3>Preethi Pal</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won India’s first-ever track medal in athletics with a bronze in the women’s 100 m T35 event.</li>
    <li style={{ fontSize: '15px' }}>Became the only Indian multi-medalist at the Games, securing another bronze in the women’s 200 m T35 event.</li>
  </ul>

  <h3>Rubina Francis</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Claimed India's fourth shooting medal with a bronze in the women’s 10 m air pistol event.</li>
  </ul>

  <h3>Sheetal Devi</h3>
  <ul style={{ listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Became the youngest Indian Paralympic medalist with a bronze in the compound archery event, paired with Rakesh Kumar.</li>
  </ul>

  <h3>Manisha Ramadass & Nithya Sivan</h3>
  <ul style={{ fontSize: '15px', listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Both won bronze medals in women’s para-badminton events, contributing to India’s impressive tally of five badminton medals.</li>
  </ul>

  <h3>Deepthi Jeevanji</h3>
  <ul style={{ fontSize: '15px', listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won the bronze in the women’s 400 m T20 race, becoming the youngest Indian track medalist in Paralympic history.</li>
  </ul>

  <h3>Kapil Parmar</h3>
  <ul style={{ fontSize: '15px', listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Secured India’s first Paralympic medal in Judo with a bronze.</li>
  </ul>

  <h3>Mariyappan Thangavelu</h3>
  <ul style={{ fontSize: '15px', listStyleType: 'circle' }}>
    <li style={{ fontSize: '15px' }}>Won bronze in the men’s high jump (1.85m).</li>
    <li style={{ fontSize: '15px' }}>Made history as the first Indian para-athlete to win medals in three consecutive Games: gold in Rio 2016, silver in Tokyo 2020, and bronze in this edition.</li>
  </ul>
</div>
<h3 style={{color:'#1773ea'}}>Proud Nation:</h3>
<p>The Prime Minister took to social media platform X to hail the “unwavering dedication and indomitable spirit” of these para-athletes.</p>
<p>“Paralympics 2024 have been special and historical,” Prime Minister Modi said in a post on X.</p>
<p>“India is overjoyed that our incredible para-athletes have brought home 29 medals, which is the best ever performance since India’s debut at the Games. This achievement is due to the unwavering dedication and indomitable spirit of our athletes. Their sporting performances have given us many moments to remember and inspired several upcoming athletes,” he added.</p>
<img src={modi} class="img-fluid" />
<p>The Paris 2024 Paralympic Games lowered the curtain on Sunday evening.</p>
<p>The closing ceremony at Stade de France was attended by approximately 64,000 spectators and more than 8,500 athletes and accompanying staff.</p>
<p>After 11 days of competition, Indian para-athletes won seven gold, nine silver, and 13 bronze medals at the Paris Paralympics</p>
<h3 style={{color:'#1773ea'}}>Conclusion</h3>
<p>India’s first medal in the Paralympics came in the 1972 Games, with Murlikant Petkar winning a gold medal in swimming. Prior to the 2024 Games, India had won 31 medals across 12 Paralympic Games.</p>
<p>India’s performance at the 2024 Paralympics not only surpassed all previous achievements but also propelled the country past the 50-medal mark in its Paralympic history.</p>

        </div>
                </div>
                </section>
              {/*  <div className="section-wrapper pl-60 pr-60">
              <div className="bostami-section-title-wrap mt-30 mb-20">
                <div className="accordion accordion-flush mt-5" id="accordionFlushExample">
                  <div className="accordion-item ">
                    <h2 className="accordion-header shadow-lg" id="flush-headingOne">
                      <button
                        className={`accordion-button ${activeAccordion === 0 ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => handleAccordionClick(0)}
                      >
                     <h2>Types of digital twins</h2>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseOne"
                      className={`accordion-collapse collapse ${activeAccordion === 0 ? 'show' : ''}`}
                      aria-labelledby="flush-headingOne"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                      <div className="bostami-what-do-wrap mb-30">
                <div className="row">
                 <p>There are various types of digital twins depending on the level of product magnification. The biggest difference between these twins is the area of application. It is common to have different types of digital twins co-exist within a system or process. Let’s go through the types of digital twins to learn the differences and how they are applied.</p>
                 <h3 style={{color:'#1b74e4'}}>Component twins or Parts twins</h3>
                 <p>Component twins are the basic unit of a digital twin, the smallest example of a functioning component. Parts twins are roughly the same thing, but pertain to components of slightly less importance.</p>
                 <h3 style={{color:'#1b74e4'}}>Asset twins</h3>
                 <p>When two or more components work together, they form what is known as an asset. Asset twins let you study the interaction of those components, creating a wealth of performance data that can be processed and then turned into actionable insights.</p>
                 <h3 style={{color:'#1b74e4'}}>System or Unit twins</h3>
                 <p>The next level of magnification involves system or unit twins, which enable you to see how different assets come together to form an entire functioning system. System twins provide visibility regarding the interaction of assets and may suggest performance enhancements.</p>
                 <h3 style={{color:'#1b74e4'}}>Process twins</h3>
                 <p>Process twins, the macro level of magnification, reveal how systems work together to create an entire production facility. Are those systems all synchronized to operate at peak efficiency, or will delays in one system affect others? Process twins can help determine the precise timing schemes that ultimately influence overall effectiveness.</p>
                </div>

              </div>
                      </div>
                    </div>
                  </div>
                 
                </div>

                <div className="accordion accordion-flush mt-5" id="accordionFlushExample2">
                  <div className="accordion-item ">
                    <h2 className="accordion-header shadow-lg" id="flush-headingTwo">
                      <button
                        className={`accordion-button ${activeAccordion === 1 ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => handleAccordionClick(1)}
                      >
                     <h2>History of digital twin technology</h2>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      className={`accordion-collapse collapse ${activeAccordion === 1 ? 'show' : ''}`}
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                      <div className="bostami-what-do-wrap mb-30">
                <div className="row">
                 <p>The idea of digital twin technology was first voiced in 1991, with the publication of Mirror Worlds, by David Gelernter. However, Dr. Michael Grieves (then on faculty at the University of Michigan) is credited with first applying the concept of digital twins to manufacturing in 2002 and formally announcing the digital twin software concept. Eventually, NASA’s John Vickers introduced a new term—“digital twin”—in 2010.</p>
               
                 <p>However, the core idea of using a digital twin as a means of studying a physical object can actually be witnessed much earlier. In fact, it can be rightfully said that NASA pioneered the use of digital twin technology during its space exploration missions of the 1960s, when each voyaging spacecraft was exactly replicated in an earthbound version that was used for study and simulation purposes by NASA personnel serving on flight crews.</p>
                
                
                
                </div>

              </div>
                      </div>
                    </div>
                  </div>
                 
                </div>

                <div className="accordion accordion-flush mt-5" id="accordionFlushExample2">
                  <div className="accordion-item ">
                    <h2 className="accordion-header shadow-lg" id="flush-headingTwo">
                      <button
                        className={`accordion-button ${activeAccordion === 2 ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => handleAccordionClick(2)}
                      >
                     <h2>Advantages and benefits of digital twins</h2>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      className={`accordion-collapse collapse ${activeAccordion === 2 ? 'show' : ''}`}
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                      <div className="bostami-what-do-wrap mb-30">
                <div className="row">
                <h3 style={{color:'#1b74e4'}}>Better R&D</h3>
                <p>The use of digital twins enables more effective research and design of products, with an abundance of data created about likely performance outcomes. That information can lead to insights that help companies make needed product refinements before starting production.</p>
                <h3 style={{color:'#1b74e4'}}>Greater efficiency</h3>
                <p>Even after a new product has gone into production, digital twins can help mirror and monitor production systems, with an eye to achieving and maintaining peak efficiency throughout the entire manufacturing process.</p>
                <h3 style={{color:'#1b74e4'}}>Product end-of-life</h3>
                <p>Digital twins can even help manufacturers decide what to do with products that reach the end of their product lifecycle and need to receive final processing, through recycling or other measures. By using digital twins, they can determine which product materials can be harvested.</p>
                
                
                </div>

              </div>
                      </div>
                    </div>
                  </div>
                 
                </div>

                <div className="accordion accordion-flush mt-5" id="accordionFlushExample2">
                  <div className="accordion-item ">
                    <h2 className="accordion-header shadow-lg" id="flush-headingTwo">
                      <button
                        className={`accordion-button ${activeAccordion === 3 ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => handleAccordionClick(3)}
                      >
                     <h2>Digital twin market and industries</h2>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      className={`accordion-collapse collapse ${activeAccordion === 3 ? 'show' : ''}`}
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                      <div className="bostami-what-do-wrap mb-30">
                <div className="row">
              
                <p>While digital twins are prized for what they offer, their use isn’t warranted for every manufacturer, or every product created. Not every object is complex enough to need the intense and regular flow of sensor data that digital twins require. Nor is it worth it from a financial standpoint to invest significant resources in the creation of a digital twin. (Keep in mind that a digital twin is an exact replica of a physical object, which could make its creation costly.)</p>
                <p>Alternatively, numerous types of projects do specifically benefit from the use of digital models:</p>
                <h3 style={{color:'#1b74e4'}}>Physically large projects</h3>
                <p>Buildings, bridges and other complex structures are bound by strict rules of engineering. </p>
                <h3 style={{color:'#1b74e4'}}>Mechanically complex projects</h3>
                <p>Jet turbines, automobiles and aircraft. Digital twins can help improve efficiency within complicated machinery and mammoth engines.</p>
                <h3 style={{color:'#1b74e4'}}>Power euipment</h3>
                <p>This includes both the mechanisms for generating power and transmitting it.</p>
                <h3 style={{color:'#1b74e4'}}>Manufacturing Projects</h3>
                <p>Digital twins excel at helping streamline process efficiency, as you would find in industrial environments with co-functioning machine systems.</p>
                <p>Therefore, the industries that achieve the most tremendous success with digital twins are those involved with large-scale products or projects:</p>
                <ul style={{fontSize:'17px',marginLeft:'30px'}}>
                    <li>Engineering (systems)</li>
                    <li>Automobile manufacturing</li>
                    <li>Aircraft production</li>
                    <li>Railcar design</li>
                    <li>Building Constructions</li>
                    <li>Manufacturing</li>
                    <li>Power utilities</li>
                </ul>
                <h3 style={{color:'#1b74e4'}}>Digital twin market: Poised for growth</h3>

                <p>The rapidly expanding digital twin market indicates that while digital twins are already in use across many industries, the demand for digital twins will continue to escalate for some time. In 2022, the global digital twins market was projected to reach USD 73.5 billion by 2027.1</p>
                </div>

              </div>
                      </div>
                    </div>
                  </div>
                 
                </div>

                <div className="accordion accordion-flush mt-5" id="accordionFlushExample2">
                  <div className="accordion-item ">
                    <h2 className="accordion-header shadow-lg" id="flush-headingTwo">
                      <button
                        className={`accordion-button ${activeAccordion === 4 ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => handleAccordionClick(4)}
                      >
                     <h2>Applications</h2>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      className={`accordion-collapse collapse ${activeAccordion === 4 ? 'show' : ''}`}
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                      <div className="bostami-what-do-wrap mb-30">
                <div className="row">
                <h3 style={{color:'#1b74e4'}}>Power-generation equipment</h3>
                <p>Large engines—including jet engines, locomotive engines and power-generation turbines—benefit tremendously from the use of digital twins, especially for helping to establish time frames for regularly needed maintenance.</p>
                <h3 style={{color:'#1b74e4'}}>Structures and their systems</h3>
                <p>Big physical structures, such as large buildings or offshore drilling platforms, can be improved through digital twins, particularly during their design. Also useful in designing the systems operating within those structures, such as HVAC systems.</p>
                <h3 style={{color:'#1b74e4'}}>Manufacturing operations</h3>
                <p>Since digital twins are meant to mirror a product’s entire lifecycle, it’s not surprising that digital twins have become ubiquitous in all stages of manufacturing, guiding products from design to finished product, and all steps in between.</p>
                <h3 style={{color:'#1b74e4'}}>Healthcare services</h3>
                <p>Just as products can be profiled by using digital twins, so can patients receiving healthcare services. The same type system of sensor-generated data can be used to track various health indicators and generate key insights.</p>
                <h3 style={{color:'#1b74e4'}}>Automotive industry</h3>
                <p>Cars represent many types of complexes, co-functioning systems, and digital twins are used extensively in auto design, both to improve vehicle performance and increase the efficiency surrounding their production.</p>
                <h3 style={{color:'#1b74e4'}}>Urban planning</h3>
               <p>Civil engineers and others involved in urban planning activities are aided significantly by the use of digital twins, which can show 3D and 4D spatial data in real time and also incorporate augmented reality systems into built environments.</p>
                </div>

              </div>
                      </div>
                    </div>
                  </div>
                 
                </div>

                <div className="accordion accordion-flush mt-5" id="accordionFlushExample2">
                  <div className="accordion-item ">
                    <h2 className="accordion-header shadow-lg" id="flush-headingTwo">
                      <button
                        className={`accordion-button ${activeAccordion === 5 ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => handleAccordionClick(5)}
                      >
                     <h2>The future of digital twin</h2>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      className={`accordion-collapse collapse ${activeAccordion === 5 ? 'show' : ''}`}
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                      <div className="bostami-what-do-wrap mb-30">
                <div className="row">
                <p>Digital twins are increasingly crucial as industries strive to improve efficiency, reduce costs, and enhance decision-making. By creating a real-time digital counterpart of a physical object or system, organizations can monitor, analyze, and optimize performance with unprecedented precision.</p>
<p>For instance, in the energy sector, digital twins of wind turbines allow operators to monitor performance in real-time, predict maintenance needs, and optimize energy output. This proactive approach not only reduces downtime but also extends the lifespan of the equipment, leading to significant cost savings.
</p>
<p>In manufacturing, digital twins are transforming production lines. By simulating different scenarios, manufacturers can identify bottlenecks, optimize workflows, and ensure quality control, all before making any physical changes. This ability to test and refine processes in a virtual environment significantly reduces the risk of errors and accelerates time-to-market.</p>
     <p>The potential of digital twins is vast and continues to expand as more cognitive power is dedicated to their development. With advancements in AI and machine learning, digital twins are becoming smarter, learning new skills and capabilities that enable them to generate deeper insights. For example, in smart cities, digital twins of urban infrastructure can help planners optimize traffic flow, reduce energy consumption, and improve public safety by simulating the impact of various changes in real-time.</p>
                </div>

              </div>
                      </div>
                    </div>
                  </div>
                 
                </div>
              
       
                
           </div>
           </div>*/}
           
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
);
};

export default Paralympics;